export const licenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjRjOGY5YmY5LWNlNmYtNDY2ZS04ZDQ3LTNkM2VjNGU2MGI1ZSIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQyCn0=.WPsEnkYT4Sf0Fm3DkqffH5p98CuHdjSeBdIsWTleTRssqcKw0nKmqkU1Nr7guKVltYLPzNEXpTdt57VzCLB3iJdHChEdijaUpgDE1uO5QP4bD0GY7Bk4UQXyXuM4jmzIWPxMwA==';
